// test253
(253 && 0);
